// src/services/api.js
//const API_BASE_URL = 'http://localhost:8000/marketplace';
//const API_BASE_URL = 'http://localhost:8000/marketplace';
const API_BASE_URL = 'https://apiv2.shup.dk/marketplace';

export const fetchProducts = async (params = {}) => {
    try {
        const url = new URL(`${API_BASE_URL}/products.php`);
        const search = new URLSearchParams();

        Object.entries(params).forEach(([k, v]) => {
            if (v !== undefined && v !== null && String(v) !== '') {
                search.append(k, String(v));
            }
        });

        url.search = search.toString();

        const resp = await fetch(url.toString());
        if (!resp.ok) throw new Error('Network response was not ok');
        return await resp.json();
    } catch (err) {
        console.error('Error fetching products:', err);
        return [];
    }
};

/**
 * NEW: Fetches artists based on a search query
 */
export const fetchArtists = async (params = {}) => {
    try {
        const url = new URL(`${API_BASE_URL}/products.php`);
        const search = new URLSearchParams();

        // Force mode and add other params (like 'q')
        params.mode = 'search_artists';
        Object.entries(params).forEach(([k, v]) => {
            if (v !== undefined && v !== null && String(v) !== '') {
                search.append(k, String(v));
            }
        });

        url.search = search.toString();

        const resp = await fetch(url.toString());
        if (!resp.ok) throw new Error('Network response was not ok');
        return await resp.json();
    } catch (err) {
        console.error('Error fetching artists:', err);
        return [];
    }
};


export const registerProductView = async (productId) => {
    try {
        await fetch(`${API_BASE_URL}/register_product_view.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ productId })
        });
    }catch (e){
        console.log(e)
    }
}
export const registerProfileView = async (subdomain) => {
    try {
        await fetch(`${API_BASE_URL}/register_profile_view.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ subdomain })
        });
    }catch (e){
        console.log(e)
    }
}

export const registerSearch = async (search) => {
    try {
        await fetch(`${API_BASE_URL}/search_recording.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ search })
        });
    } catch (e) {
        console.error(e);
    }
};